import { Pagination, Spin } from "antd";
import React, { useState } from "react";
import { useQuery } from "react-query";
import { useNavigate } from "react-router-dom";
import ModelListCard from "../../components/ModelsList/ModelListCard";
import PlusIconActionButton from "../../components/PlusIconActionButton";
import useLogout from "../../hooks/useLogout";
import { fetchModalList, useFetchModels } from "../../hooks/useSkuModal";

const AllModels = () => {
  const [pageNumber, setPageNumber] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const navigate = useNavigate();
  const [totalPage, setTotalPage] = useState(0);
  // const {
  //   data: allModels,
  //   isLoading,
  //   isError,
  //   refetch: refetchModels,
  // } = useFetchModels();
  // fetchModalList
  const {
    data: allModels,
    isError,
    isLoading,
    refetch: refetchModels,
    isFetching,
  } = useQuery(["listing", pageNumber, pageSize], fetchModalList, {
    // refetchOnWindowFocus: false,
    // select: (data) => data.data,
    // onSuccess: onSuccessStudio,
    onSuccess: (data) => setTotalPage(data.data?.totalCount),
    retry: (failureCount, error) =>
      failureCount < 3 && error?.response?.status !== 401,
  });
  const { logout } = useLogout();
  const spinRender = () => {
    return (
      <div className="spin-center">
        <Spin className="spin_loader" size="large" />{" "}
      </div>
    );
  };

  if (isError) {
    logout();
  }

  const fetchNextData = (pageNum) => {
    let pageNo = pageNum++;
    setPageNumber(pageNo);
  };

  return (
    <div>
      <h5>All Models: </h5>
      <div
        style={{
          height: "78vh",
          marginTop: "2px",
          overflow: "auto",
          display: "flex",
          flexWrap: "wrap",
        }}
      >
        {isFetching ? (
          spinRender()
        ) : (
          <>
            {allModels &&
              allModels?.data?.data
                .filter((item) => item.isPublic)
                .map((model, index) => (
                  <ModelListCard
                    key={model._id}
                    modelId={model._id}
                    baseFace={model.baseFace}
                    name={model.name}
                    isPublic={model.isPublic}
                    refetchModels={() => refetchModels()}
                  />
                ))}
            {allModels &&
              allModels?.data?.data
                .filter((item) => !item.isPublic)
                .map((model, index) => (
                  <ModelListCard
                    key={model._id}
                    modelId={model._id}
                    baseFace={model.baseFace}
                    name={model.name}
                    isPublic={model.isPublic}
                    refetchModels={() => refetchModels()}
                  />
                ))}
          </>
        )}
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          paddingTop: "1rem",
        }}
      >
        <Pagination
          current={pageNumber}
          total={totalPage}
          onChange={(page) => {
            fetchNextData(page);
          }}
          pageSizeOptions={["10", "20", "50"]}
          pageSize={pageSize}
          defaultPageSize={pageSize}
          showSizeChanger
          onShowSizeChange={(current, size) => {
            setPageSize(size);
            setPageNumber(1);
          }}
        />
      </div>
      <PlusIconActionButton
        onClick={() => navigate("/addModel")}
        title={"Add Model"}
      />

      {/* {showCsvModal && (
        <DynamicModal
          open={true}
          width={1000}
          component={
            <ManageCsv
              csvId={csvId}
              csvOrder={data?.data ?? []}
              setShowCsvModal={setShowCsvModal}
              getCsv={getCsv}
            />
          }
        />
      )} */}
    </div>
  );
};

export default AllModels;
